import { Badge } from '../atoms/Badge';
import { cn } from '../lib/cn';

export type SlaState = 'ok' | 'warning' | 'danger' | 'breach';

export interface SlaBadgeProps {
  state: SlaState;
  label: string;
  className?: string;
}

export function SlaBadge({ state, label, className }: SlaBadgeProps) {
  return (
    <Badge variant="sla" sla={state} className={cn('font-mono text-xs', className)}>
      SLA: {label}
    </Badge>
  );
}
